<div class="modal">
  <div class="modal-header" [class.scrolled]="isScrolled">
    <div class="modal-header__main">
      <div class="icon-container">
        <ion-icon class="i-info-fill" aria-label="Información"></ion-icon>
      </div>
      <h2 class="modal-title">{{modalBeneficiosReforma.textosBeneficios.tituloModal}}</h2>
    </div>
    <button
      type="button"
      class="modal-close-button"
      (click)="closeButtonCallback()"
      aria-label="Cerrar">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>

  <div class="modal-body" #scrollContainer (scroll)="onScroll($event)">
    <div class="main-content">
      <p class="description" [innerHTML]="modalBeneficiosReforma.textosBeneficios.parrafoPrincipal"></p>

      <output
        *ngIf="mostrarAlertaCompensacionExpectativaVida"
        class="alerta-compensacion">
        <div class="icon-container alerta-compensacion__icon">
          <ion-icon class="i-info-fill-2" aria-hidden="true"></ion-icon>
        </div>
        <p class="alerta-compensacion__text">{{ textoAlertaCompensacionExpectativaVida }}</p>
      </output>

      <div class="accordion">
        <details *ngFor="let item of modalBeneficiosReforma.textosBeneficios.beneficios; let i = index"
          [open]="item.abierto">
          <summary (click)="toggleItem(item, $event)" (keydown.enter)="toggleItem(item, $event)">

            <div class="summary-content">
              <div class="item-icon-wrapper">
                <img [src]="item.rutaIcono" alt="" />
              </div>
              <span class="card-title">{{ item.tituloBeneficio }}</span>
            </div>
            <div class="question-icon">
              <ion-icon class="arrow" [class.open]="item.abierto" name="chevron-down-outline"></ion-icon>
            </div>
          </summary>

          <div class="details-content" id="panel-{{ i }}">
            <p class="description" *ngFor="let paragraph of item.parrafos" [innerHTML]="paragraph"></p>

            <div *ngIf="item.requisitos.length">
              <p class="description">
                <strong>{{ item.tituloRequisitos }}</strong>
              </p>

              <ul>
                <li *ngFor="let req of item.requisitos">
                  {{ req }}
                </li>
              </ul>
            </div>

            <div class="details-content-bottom">
              <div class="details-subcontent-bottom" (click)="goToBeneficio(item)"
                (keydown.enter)="goToBeneficio(item)">
                <p>Revisa más</p>
                <img src="/assets/reforma-pensiones/revisar.svg" alt="" />
              </div>
            </div>
          </div>
        </details>
      </div>
    </div>

    <div class="advice-section">
      <p class="advice-section-title">
        ¿Necesitas saber si puedes acceder a estos beneficios?
      </p>
      <p class="advice-section-description">
        Te sugerimos asesorarte con nuestros ejecutivos a través de una
        <a
          href="/video-atencion"
          class="advice-inline-link"
          (click)="goToVideoAtencion($event)"
          (keydown.space)="$event.preventDefault(); goToVideoAtencion($event)"
        >Video Atención</a>
        o llamando al
        <a href="tel:+6006600900">600 6600 900</a>.
      </p>
    </div>

    <div class="info-box">
      <div class="icon-container info-box-icon" aria-hidden="true">
        <ion-icon class="i-info-fill-2" aria-hidden="true"></ion-icon>
      </div>
      <div>
        <p class="info-box-title">Importante</p>
        <p class="info-box-description">
          Estos beneficios aplican solo para pensionados. Ambas prestaciones se suspenden si se reside fuera de Chile
          por más de 180 días (seguidos o no) dentro de un año calendario, pero puede reactivarse si la persona vuelve
          al país y permanece al menos 180 días.
        </p>
      </div>

    </div>
  </div>

  <div class="modal-footer" [class.scrolled]="isScrolled">
    <div class="footer-buttons-wrapper">
      <button class="btn-primary" type="button" (click)="goToVideoAtencion()" (keydown.enter)="goToVideoAtencion()">
        Agendar Video Atención
      </button>
      <button class="btn-secondary" type="button" (click)="goToTramitePension()" (keydown.enter)="goToTramitePension()">
        Ir a la solicitud
      </button>
    </div>
  </div>
</div>